module.exports = __webpack_public_path__ + "static/Posters-75b48472bb579164020dc52ff1e3f298.svg";